var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"subject-videos-body"}},_vm._l((_vm.newsList),function(item){return _c('div',{key:item.id,staticClass:"news-item",style:({
      border:
        _vm.showBorder == 2
          ? '2px solid #FFF'
          : _vm.showBorder == 1
          ? '2px solid #000'
          : '0px',
    }),on:{"click":function($event){return _vm.goToDetail(item.id)}}},[_c('img',{staticStyle:{"height":"98px","width":"100%"},attrs:{"src":_vm.getImageURL(item.cover)}}),_c('div',{staticClass:"textT",staticStyle:{"text-align":"left","padding":"5px","background":"#fff","margin-top":"-5px"}},[_vm._v("\n      "+_vm._s(item.title)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }